/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/customTaskHandlers/contractBasedInvoiceHandlers/manualSplitTax"/>
import { addHandler } from "Core/Medius.Core.Web/Scripts/Medius/core/customTaskHandlers/customTaskHandlersProvider";
import * as remediumApi from "Core/Medius.Core.Web/Scripts/Medius/core/communication/remediumApi";
import { isContractBasedInvoiceRemediumFlowEnabled } from "Core/Medius.Core.Web/Scripts/Medius/core/featureToggle";

export function register() {
    addHandler({
        canHandle: function (vm: any, _task: any) {
            if(isContractBasedInvoiceRemediumFlowEnabled())
            {
                const isRemediumWorkflow = _task.WorkflowContext() === null;
                const isSplitTax = vm.Code && vm.Code() === "SplitTaxCodeResult";
                const isContractBasedInvoice = _task.Document().$type() === "Medius.ContractbasedInvoice.Entities.ContractbasedInvoice, Medius.ContractbasedInvoice.Common";
                return isRemediumWorkflow && isContractBasedInvoice && isSplitTax;
            }

            return false;
        },
        handle: function (task: any, _: any) {
            return function () {
                return remediumApi.post("remedium-api/contractBasedInvoice/workflow/completeManualSplitTax", {
                    DocumentId: task.Document().Id(),
                    UserTaskId: task.Id()
                });
            };
        }
    });
}